var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "forexcontainer", attrs: { id: "Forex" } }, [
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !Object.keys(_vm.apiData).length > 0 && !_vm.retry == 0,
            expression: "!Object.keys(apiData).length > 0 && !retry == 0",
          },
        ],
        attrs: { id: "forexLoading" },
      },
      [
        _c("img", {
          staticStyle: { margin: "0px 0px 10px 0px" },
          attrs: {
            src: "/images/2015/forex_loading.gif",
            alt: "currency trading",
            border: "0",
            align: "left",
          },
        }),
        _c("br"),
        _vm._v("Real-Time Currency Quotes Loading\n"),
      ]
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.retry == 0,
            expression: "retry==0",
          },
        ],
        attrs: { id: "forexError" },
      },
      [
        _c("Real-Time", [
          _vm._v("Currency Quotes"),
          _c("br"),
          _c(
            "span",
            { staticStyle: { "font-size": "28px", color: "#DAD188" } },
            [_vm._v("Markets Closed or Unavailable")]
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: Object.keys(_vm.apiData).length > 0,
            expression: "Object.keys(apiData).length > 0",
          },
        ],
        attrs: { id: "forexLoaded" },
      },
      [
        _c(
          "span",
          {
            staticStyle: {
              display: "block",
              "padding-bottom": "10px",
              "border-bottom": "1px solid #666666",
            },
          },
          [_vm._v("Real-Time Currency Quotes")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "table-responsive" }, [
          _c(
            "table",
            {
              staticClass: "fxtable",
              attrs: {
                id: "forexTable",
                width: "100%",
                cellspacing: "0",
                cellpadding: "0",
                border: "0",
              },
            },
            _vm._l(_vm.conIds.length / 2, function (sym) {
              return _c("tr", [
                _c(
                  "td",
                  {
                    staticClass: "fxcurrency",
                    attrs: { width: "10%", align: "left", valign: "middle" },
                  },
                  [_vm._v(_vm._s(_vm.apiData[_vm.conIds[sym - 1]]["symbol"]))]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "fxbidaskspread",
                    attrs: { width: "12%", align: "left", valign: "middle" },
                  },
                  [
                    _vm._v("BID "),
                    _c(
                      "span",
                      {
                        staticClass: "fxprice",
                        class: [_vm.apiData[_vm.conIds[sym - 1]]["bDiff"]],
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.apiData[_vm.conIds[sym - 1]]["bPrice"])
                        ),
                        _c("sup", [
                          _vm._v(
                            _vm._s(_vm.apiData[_vm.conIds[sym - 1]]["bSup"])
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "fxbidaskspread",
                    attrs: { width: "14%", align: "left", valign: "middle" },
                  },
                  [
                    _vm._v("ASK "),
                    _c(
                      "span",
                      {
                        staticClass: "fxprice",
                        class: [_vm.apiData[_vm.conIds[sym - 1]]["aDiff"]],
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.apiData[_vm.conIds[sym - 1]]["aPrice"])
                        ),
                        _c("sup", [
                          _vm._v(
                            _vm._s(_vm.apiData[_vm.conIds[sym - 1]]["aSup"])
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "fxbidaskspread",
                    attrs: { width: "12%", align: "left", valign: "middle" },
                  },
                  [
                    _vm._v("SPRD "),
                    _c("span", { staticClass: "fxprice" }, [
                      _vm._v(
                        _vm._s(_vm.apiData[_vm.conIds[sym - 1]]["spread"])
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                sym == 1
                  ? _c("td", {
                      staticClass: "fxdivider",
                      attrs: { rowspan: "4", width: "1%" },
                    })
                  : _vm._e(),
                sym == 1
                  ? _c("td", { attrs: { rowspan: "4", width: "3%" } }, [
                      _vm._v(" "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "fxcurrency",
                    attrs: { width: "10%", align: "left", valign: "middle" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.apiData[
                          _vm.conIds[sym + _vm.conIds.length / 2 - 1]
                        ]["symbol"]
                      )
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "fxbidaskspread",
                    attrs: { width: "12%", align: "left", valign: "middle" },
                  },
                  [
                    _vm._v("BID "),
                    _c(
                      "span",
                      {
                        staticClass: "fxprice",
                        class: [_vm.apiData[_vm.conIds[sym - 1]]["bDiff"]],
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.apiData[
                              _vm.conIds[sym + _vm.conIds.length / 2 - 1]
                            ]["bPrice"]
                          )
                        ),
                        _c("sup", [
                          _vm._v(
                            _vm._s(
                              _vm.apiData[
                                _vm.conIds[sym + _vm.conIds.length / 2 - 1]
                              ]["bSup"]
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "fxbidaskspread",
                    attrs: { width: "14%", align: "left", valign: "middle" },
                  },
                  [
                    _vm._v("ASK "),
                    _c(
                      "span",
                      {
                        staticClass: "fxprice",
                        class: [_vm.apiData[_vm.conIds[sym - 1]]["aDiff"]],
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.apiData[
                              _vm.conIds[sym + _vm.conIds.length / 2 - 1]
                            ]["aPrice"]
                          )
                        ),
                        _c("sup", [
                          _vm._v(
                            _vm._s(
                              _vm.apiData[
                                _vm.conIds[sym + _vm.conIds.length / 2 - 1]
                              ]["aSup"]
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "fxbidaskspread",
                    attrs: { width: "12%", align: "left", valign: "middle" },
                  },
                  [
                    _vm._v("SPRD "),
                    _c("span", { staticClass: "fxprice" }, [
                      _vm._v(
                        _vm._s(
                          _vm.apiData[
                            _vm.conIds[sym + _vm.conIds.length / 2 - 1]
                          ]["spread"]
                        )
                      ),
                    ]),
                  ]
                ),
              ])
            }),
            0
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }